import { useEffect, useState } from 'react';
import ConfigInstanceService from '../services/configInstance.service';

export const REPORT_PRIVACY_CHANGED = 'report-privacy-changed';
type ReportPrivacyState = { hidden: boolean; ready: boolean; error: boolean; revision: number };

export default function useReportPrivacy(enabled = true) {
  const [state, setState] = useState({ hidden: false, ready: false, error: false, revision: 0 });

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    let request = 0;
    const apply = (hidden: boolean) => setState((previous: ReportPrivacyState) => ({
      hidden, ready: true, error: false,
      revision: previous.revision + (!previous.ready || previous.hidden !== hidden ? 1 : 0),
    }));
    const refresh = async () => {
      const sequence = ++request;
      try {
        const response = await new ConfigInstanceService().getReportPrivacy();
        const hidden = response?.data?.data?.hideUserInfoInReports;
        if (!response?.data?.success || typeof hidden !== 'boolean') throw new Error('Invalid privacy response');
        if (active && sequence === request) apply(hidden);
      } catch {
        if (active && sequence === request) setState((previous: ReportPrivacyState) => ({ ...previous, ready: false, error: true }));
      }
    };
    const changed = (event: Event) => {
      ++request; // Ignore any read started before the confirmed save.
      apply((event as CustomEvent<boolean>).detail);
    };
    refresh();
    const interval = window.setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    window.addEventListener(REPORT_PRIVACY_CHANGED, changed);
    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(REPORT_PRIVACY_CHANGED, changed);
    };
  }, [enabled]);

  return state as ReportPrivacyState;
}
